module.exports = {
  publicAssetsPrefix: 'https://mobile.poll.fish',
};
